import React, { useEffect, useState } from "react";
import {
  BackButton,
  ClearFilterButton,
  EditButton,
  FilterButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation, useParams } from "react-router-dom";
import { GetAccess } from "../../../../Components/Utils/roles";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { useContacts } from "./ContractsContext";
import axiosInstance from "../../../../Services/axiosCommon";

const ContractLayout = ({
  setSearchQuery = () => {},
  EditAccess = false,
  children,
  isFilter = false,
  setFilterOpen = () => {},
  newfilter = false,
  ClearFilter = () => {},
}) => {
  const { inspectionView, equipmentsView, serviceView, invoiceView,updateIsContractViewUpdate,isContractViewUpdate,updateInspection,updateEquipments,updateInvoice,updateService, } = useContacts();
  const location = useLocation();
  const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const from = location.state?.from || -1;
  const { pathname } = useLocation();
  const { contractsViewId } = useParams();
  const [module, setModule] = useState("");
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function getTabFuction() {
    axiosInstance.get(`/dashboard/contract-view/${contractsViewId}`).then(res=>{
      if(res?.data){
        const { inspection, equipments, service, invoice } = res?.data?.data;
        updateIsContractViewUpdate(true);
        updateInspection(inspection);
        updateEquipments(equipments);
        updateService(service);
        updateInvoice(invoice);
      }
    }).catch(err=>{
      console.log(err);
      
    })
  }

  useEffect(() => {
    if(isContractViewUpdate == false){
      getTabFuction();
    }
  },[isContractViewUpdate,contractsViewId])

  useEffect(() => {
    if (pathname == `/Contract-management/contracts/view/${contractsViewId}`) {
      setModule("Details");
    } else if (
      pathname == `/Contract-management/contracts/inspection/${contractsViewId}`
    ) {
      setModule("Inspection");
    } else if (
      pathname == `/Contract-management/contracts/equipments/${contractsViewId}`
    ) {
      setModule("Equipments");
    } else if (
      pathname == `/Contract-management/contracts/service/${contractsViewId}`
    ) {
      setModule("Service");
    } else if (
      pathname == `/Contract-management/contracts/invoice/${contractsViewId}`
    ) {
      setModule("Invoice");
    }
  }, [pathname]);

  const NavTab = [
    {
      key: "contracts_view",
      label: "Details",
      path: `/Contract-management/contracts/view/${contractsViewId}`,
      view: true,
    },
    {
      key: "contracts_inspection",
      label: "Inspection",
      path: `/Contract-management/contracts/inspection/${contractsViewId}`,
      view: inspectionView || false,
    },
    {
      key: "contracts_equipments",
      label: "Equipments",
      path: `/Contract-management/contracts/equipments/${contractsViewId}`,
      view: equipmentsView || false,
    },
    {
      key: "contracts_service",
      label: "Service",
      path: `/Contract-management/contracts/service/${contractsViewId}`,
      view: serviceView || false,
    },
    {
      key: "contracts_invoice",
      label: "Invoice",
      path: `/Contract-management/contracts/invoice/${contractsViewId}`,
      view: invoiceView || false,
    },
  ];

  return (
    <>
      <div className=" w-full  h-full py-2 px-4 md:overflow-hidden">
        <div className="sm:flex justify-between w-full ">
          <Breadcrumb
            items={[
              {
                name: "Contracts",
                link: "/Contract-management/contracts",
              },

              { name: module },
            ]}
          />
          <div className="flex gap-2 justify-end">
            {newfilter && (
              <>
                <FilterButton
                  label="Filter"
                  handleClick={() => {
                    setFilterOpen(true);
                    setSearchQuery("");
                  }}
                />
                {isFilter && (
                  <ClearFilterButton label="Clear" handleClick={ClearFilter} />
                )}{" "}
              </>
            )}
            <div className=" flex justify-end items-center gap-3 ">
              <div className=" flex gap-2">
               <BackButton
  link={true}
  hasLink={
    module !== "Details"
      ? `/Contract-management/contracts`
      : `/Contract-management/contracts`
  }
  state={
    module === "Details"
      ? {
          currentPage: pageIndex,
          searchQuery: searchQuery !== "" ? searchQuery : "",
        }
      : null
  }
/>

                {EditAccess && (
                  <Link
                    to={`/Contract-management/contracts/edit/${contractsViewId}`}
                    state={{
                      data: data,
                      from: `/Contract-management/contracts/view/${contractsViewId}`,
                    }}
                  >
                    <EditButton height="8" />
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide">
          <div className="inline-flex items-center gap-x-1">
            {NavTab &&
              NavTab.map((item, i) => {
                const isActive = item?.path === pathname;
                return (
                  <React.Fragment key={item?.path || i}>
                    {GetAccess(item?.key) && item?.view === true && (
                      <Link
                        to={item?.path}
                        className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5 inline-block
                ${
                  isActive
                    ? "bg-baseColor-primary text-white"
                    : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                }`}
                      >
                        {item?.label || ""}
                      </Link>
                    )}
                  </React.Fragment>
                );
              })}
          </div>
        </div>
        <div className=" w-full h-[calc(100vh-211px)] md:h-[calc(100vh-160px)] ">{children}</div>
      </div>
    </>
  );
};

export default ContractLayout;
